const SERVICES_LIST_KEYS = ['services_list']
const SERVICES_NETWORK_KEYS = ['service_page']
const SERVICES_ACCOUNT_KEYS = ['service_network_account']
const SERVICES_ACCESS_KEYS = ['service_network_account_access_management', 'service_network_account_access_create']
const SERVICES_ACCOUNT_CREATE_KEYS = ['service_account_register', 'service_account_register_multilogin']
const SERVICES_REFUND_KEYS = ['service_network_account_refund']
const SERVICES_ADVERTISER_KEYS = ['service_network_account_tax_info_edit']
const SERVICES_CAMPAIGNS_KEYS = [
  'service_network_account_campaigns',
  'service_network_account_campaign_create',
  'service_network_account_campaign_start',
]
const SERVICES_EDITOR_KEYS = ['service_campaigns_editor', 'service_campaigns_editor_resource']
const SERVICES_MEDIA_PLANNER_KEYS = ['service_media_planner_page']
const SERVICES_AUTOREPLENISH_KEYS = ['auto_replenish']

/** Routes that dispatch FETCH_NETWORK_ACCOUNT or read services/network-account. */
const SERVICES_ROUTES_NEEDING_NETWORK_ACCOUNT = [
  ...SERVICES_ACCOUNT_KEYS,
  ...SERVICES_ACCESS_KEYS,
  ...SERVICES_REFUND_KEYS,
]

/** Routes that resolve :networkType → network id via useNetworksData (needs list reducer + saga). */
const SERVICES_NETWORKS_LOOKUP_ROUTE_KEYS = [
  ...SERVICES_LIST_KEYS,
  ...SERVICES_NETWORK_KEYS,
  ...SERVICES_ACCOUNT_KEYS,
  ...SERVICES_ACCESS_KEYS,
  ...SERVICES_ACCOUNT_CREATE_KEYS,
  ...SERVICES_ADVERTISER_KEYS,
]

export default [
  {
    reducerKey: 'services/list',
    sagaKey: 'servicesListSaga',
    routeKeys: SERVICES_NETWORKS_LOOKUP_ROUTE_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/NetworksList/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/NetworksList/store/saga'),
  },
  {
    reducerKey: 'services/network',
    sagaKey: 'servicesNetworkSaga',
    routeKeys: SERVICES_NETWORK_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Network/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Network/store/saga'),
  },
  {
    reducerKey: 'services/network-account',
    sagaKey: 'servicesAccountSaga',
    routeKeys: SERVICES_ROUTES_NEEDING_NETWORK_ACCOUNT,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Account/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Account/store/saga'),
  },
  {
    reducerKey: 'services/account-access',
    sagaKey: 'servicesAccessSaga',
    routeKeys: SERVICES_ACCESS_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Access/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Access/store/saga'),
  },
  {
    sagaKey: 'servicesRefundSaga',
    routeKeys: SERVICES_REFUND_KEYS,
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Refund/store/saga'),
  },
  {
    reducerKey: 'services/account-create',
    sagaKey: 'servicesAccountCreateSaga',
    routeKeys: SERVICES_ACCOUNT_CREATE_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/AccountCreate/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/AccountCreate/store/saga'),
  },
  {
    sagaKey: 'accountAdvertiserInfoEditSaga',
    routeKeys: SERVICES_ADVERTISER_KEYS,
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/AccountAdvertiserInfoEdit/saga'),
  },
  {
    reducerKey: 'services/campaigns',
    sagaKey: 'servicesCampaignsSaga',
    routeKeys: SERVICES_CAMPAIGNS_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Campaigns/Main/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Campaigns/Main/store/saga'),
  },
  {
    reducerKey: 'services/campaign',
    sagaKey: 'servicesCampaignSaga',
    routeKeys: SERVICES_CAMPAIGNS_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Campaigns/Start/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/Campaigns/Start/store/saga'),
  },
  {
    reducerKey: 'services/campaigns-editor',
    sagaKey: 'campaignsEditorSaga',
    routeKeys: SERVICES_EDITOR_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/CampaignsEditor/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Services/CampaignsEditor/store/saga'),
  },
  {
    reducerKey: 'services/budget-editor',
    sagaKey: 'budgetEditorSaga',
    routeKeys: SERVICES_EDITOR_KEYS,
    importReducer: () =>
      import(/* webpackChunkName: "domain-services" */ 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/reducer'),
    importSaga: () =>
      import(/* webpackChunkName: "domain-services" */ 'modules/Services/CampaignsEditor/subcomponents/BudgetEditor/saga'),
  },
  {
    reducerKey: 'stories',
    sagaKey: 'storiesSaga',
    routeKeys: SERVICES_LIST_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Stories/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Stories/store/saga'),
  },
  {
    reducerKey: 'media-planner',
    sagaKey: 'mediaPlannerSaga',
    routeKeys: SERVICES_MEDIA_PLANNER_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/MediaPlanner/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/MediaPlanner/store/saga'),
  },
  {
    reducerKey: 'autoreplenish',
    sagaKey: 'autoReplenishSaga',
    routeKeys: SERVICES_AUTOREPLENISH_KEYS,
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/AutoReplenish/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/AutoReplenish/store/saga'),
  },
  {
    reducerKey: 'countries',
    sagaKey: 'countriesSaga',
    routeKeys: [...SERVICES_ACCOUNT_CREATE_KEYS, ...SERVICES_ADVERTISER_KEYS],
    importReducer: () => import(/* webpackChunkName: "domain-services" */ 'modules/Countries/store/reducer'),
    importSaga: () => import(/* webpackChunkName: "domain-services" */ 'modules/Countries/store/saga'),
  },
]
